import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApronDto, ApproveOperationDto, MarkPendingDto, PosValidateManagerPinRequestDto, PosValidateManagerPinResponseDto } from '@up/data';
import { ENV_OPTIONS } from '@up/shared/injection-tokens';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from "../../services/BaseService.service";

@Injectable({
  providedIn: 'root'
})
export class ApronService extends BaseService<ApronDto> {
  private employeeUrl: string;

  constructor(@Inject(ENV_OPTIONS) environmentOptions: any,
              httpClient: HttpClient) {
    super(environmentOptions, httpClient);
    this.employeeUrl = `${environmentOptions.apiUrl}/employee`

    this.apiEndPoint = 'aprons';
    this.title = 'Aprons';
  }

  getById(id: string | number): Observable<ApronDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = this.getFullUrl() + `/${id}`;

    return this.httpClient
      .get<ApronDto>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  validateManagerAccess(
    validatePOSPinRequest: PosValidateManagerPinRequestDto
  ): Observable<PosValidateManagerPinResponseDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = `${this.employeeUrl}/validate-manager-pin`;

    return this.httpClient
      .post<PosValidateManagerPinResponseDto>(url, validatePOSPinRequest, { headers })
      .pipe(
        map(data => data),
        catchError(this.handleError)
      );
  }

  markStartPending(id: number, dto: MarkPendingDto): Observable<ApronDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = this.getFullUrl() + `/${id}/pending-start`;

    return this.httpClient
      .patch<ApronDto>(url, dto, { headers })
      .pipe(catchError(this.handleError));
  }

  approveStart(id: number, dto: ApproveOperationDto): Observable<ApronDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = this.getFullUrl() + `/${id}/approve-start`;

    return this.httpClient
      .patch<ApronDto>(url, dto, { headers })
      .pipe(catchError(this.handleError));
  }

  markDropPending(id: number, dto: MarkPendingDto): Observable<ApronDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = this.getFullUrl() + `/${id}/pending-drop`;

    return this.httpClient
      .patch<ApronDto>(url, dto, { headers })
      .pipe(catchError(this.handleError));
  }

  approveDrop(id: number, dto: ApproveOperationDto): Observable<ApronDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = this.getFullUrl() + `/${id}/approve-drop`;

    return this.httpClient
      .patch<ApronDto>(url, dto, { headers })
      .pipe(catchError(this.handleError));
  }

  markEndPending(id: number, dto: MarkPendingDto): Observable<ApronDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = this.getFullUrl() + `/${id}/pending-end`;

    return this.httpClient
      .patch<ApronDto>(url, dto, { headers })
      .pipe(catchError(this.handleError));
  }

  approveEnd(id: number, dto: ApproveOperationDto): Observable<ApronDto> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer 58e4575f-c27f-449c-a287-b668f55e8bce'
    });

    const url = this.getFullUrl() + `/${id}/approve-end`;

    return this.httpClient
      .patch<ApronDto>(url, dto, { headers })
      .pipe(catchError(this.handleError));
  }
}
